export default "__VITE_ASSET__fdad759e__"